import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { useLenis } from "@/lib/useLenis";
import { Navbar } from "@/components/ur/Navbar";
import { Footer } from "@/components/ur/Footer";
import { FloatingActions } from "@/components/ur/FloatingActions";
import { MobileCTA } from "@/components/ur/MobileCTA";
import { Chatbot } from "@/components/ur/Chatbot";
import { Toaster } from "@/components/ui/sonner";
import { Login } from "@/pages/Login";
import { Admin } from "@/pages/Admin";
import { Home } from "@/pages/Home";
import { Products, ProductDetail } from "@/pages/Products";
import { ModularKitchen, Wardrobes, Doors, HomeInteriors, HomeRenovation, ServicesPage, AboutPage, ContactPage, BlogPage, BlogDetail, FAQPage, Privacy, Terms } from "@/pages/Static";
import { BathroomRenovation } from "@/pages/BathroomRenovation";
import { Projects as ProjectsSection } from "@/components/ur/Projects";
import { Gallery } from "@/components/ur/Gallery";
import { FinalCTA } from "@/components/ur/FinalCTA";

function DesignsPage() {
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <>
      <div className="pt-32 pb-8 bg-canvas">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="overline text-ink-soft">Designs & Inspiration</div>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold text-ink leading-tight">Design ideas &amp; inspiration</h1>
        </div>
      </div>
      <Gallery />
      <FinalCTA />
    </>
  );
}
function ProjectsPage() {
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <>
      <div className="pt-32 pb-4 bg-canvas">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="overline text-ink-soft">Projects</div>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold text-ink leading-tight">Our interior &amp; renovation projects</h1>
        </div>
      </div>
      <ProjectsSection />
      <FinalCTA />
    </>
  );
}

function Shell({ children }) {
  useLenis();
  return (
    <div className="App bg-canvas text-ink min-h-screen">
      <Navbar />
      <main>{children}</main>
      <Footer />
      <FloatingActions />
      <MobileCTA />
      <Chatbot />
      <Toaster richColors position="bottom-center" />
    </div>
  );
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/products" element={<Shell><Products /></Shell>} />
      <Route path="/product/:slug" element={<Shell><ProductDetail /></Shell>} />
      <Route path="/modular-kitchen-gurgaon" element={<Shell><ModularKitchen /></Shell>} />
      <Route path="/modular-wardrobes-gurgaon" element={<Shell><Wardrobes /></Shell>} />
      <Route path="/designer-doors-gurgaon" element={<Shell><Doors /></Shell>} />
      <Route path="/home-interior-design-gurgaon" element={<Shell><HomeInteriors /></Shell>} />
      <Route path="/home-renovation-gurgaon" element={<Shell><HomeRenovation /></Shell>} />
      <Route path="/bathroom-renovation-gurgaon" element={<Shell><BathroomRenovation /></Shell>} />
      <Route path="/services" element={<Shell><ServicesPage /></Shell>} />
      <Route path="/designs" element={<Shell><DesignsPage /></Shell>} />
      <Route path="/projects" element={<Shell><ProjectsPage /></Shell>} />
      <Route path="/about" element={<Shell><AboutPage /></Shell>} />
      <Route path="/contact" element={<Shell><ContactPage /></Shell>} />
      <Route path="/blog" element={<Shell><BlogPage /></Shell>} />
      <Route path="/blog/:slug" element={<Shell><BlogDetail /></Shell>} />
      <Route path="/faq" element={<Shell><FAQPage /></Shell>} />
      <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
      <Route path="/terms" element={<Shell><Terms /></Shell>} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Shell><Home /></Shell>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
